import AddIcon from "@mui/icons-material/Add";

import { Box, InputAdornment, Pagination, Paper, TextField, Typography, useTheme, Stack } from "@mui/material";
import CustomHeader from "../../../core/components/common/custom-header.component";
import DeviceManagementListComponent from "../components/device-management-list.component";
import { useDeviceManagement } from "../hooks/useDeviceManagement";
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';

import CustomListviewLoader from "../../../core/components/common/custom-listview-loader.component";
import CustomButton from "../../../core/components/ui/CustomButton";
import { RBACUIGuard, useRBACStore } from "../../RBACPlugin";
import { permissions } from "../../../core/components/common/variables/static_variables";

import CustomFilterComponent from "../../../core/components/common/custom-filter.component";
import Select from 'react-select';
import useDeviceStore from "../zustand/useDeviceStore";

export default function DeviceManagementListPage () {
    
    const {deviceList, list, isLoadingDevice, filterDeviceList, filterList} = useDeviceManagement();
    const {isDeviceUpdated} = useDeviceStore();

    const rowsPerPage = 10;

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [viewDeviceDetails, setViewDeviceDetails] = useState(false);
    const [filterLabel, setFilterLabel] = useState(null);

    const navigate = useNavigate();
    const {hasPermission} = useRBACStore()

    const [selectedField, setSelectedField] = useState(null);
    const [searchValue, setSearchValue] = useState('');
    const [isFiltering, setIsFiltering] = useState(false);

    const theme = useTheme();

    const customStyles = {
        control: (base, state) => ({
            ...base,
            height: 42,
            backgroundColor: 'transparent',
            width: 250,
            fontSize: 14,
            borderColor: state.isFocused ? theme.palette.primary.main : "#dce8f5",
            boxShadow: state.isFocused ? `0 0 0 1px ${theme.palette.primary.main}` : "none",
            '&:hover': {
                borderColor: theme.palette.primary.main
            }
        }),
        placeholder: base => ({
            ...base,
            fontSize: 12
        }),
        menu: provided => ({
            ...provided,
            zIndex: 99999,
            fontSize: 14
        }),
    }


    const handleFieldChange = (selectedOption) => {
        setSelectedField(selectedOption);
        setSearchValue('');
    };

    const handleInputChange = (event) => {
        setSearchValue(event.target.value);
    };

   const handleSearch = () => {
    if (selectedField && searchValue) {
        const params = {
            searchFor: selectedField.value,
            searchVal: searchValue,
            page: 1,
            limit: rowsPerPage,
        };
        filterDeviceList(params);
        setCurrentPage(1);
        setIsFiltering(true);
    }
};

    const handleChangePagination = (event, page) => { 
    setCurrentPage(page);

    const params = {
        page,
        limit: rowsPerPage,
    };

    if (isFiltering && selectedField && searchValue) {
        filterDeviceList({
            searchFor: selectedField.value,
            searchVal: searchValue,
            ...params
        });
    } else {
        deviceList(params);
    }
};

useEffect(() => {
    if (isDeviceUpdated) {
        const parameters = {
            page: currentPage,
            limit: rowsPerPage,
        };
        deviceList(parameters);
    }
}, [isDeviceUpdated]);


    //  useEffect(() => {
    //     const parameters = {
    //         page: 1,
    //         limit: rowsPerPage,
    //     }

    //     deviceList(parameters);
    // }, [])

    useEffect(() => {
        if (!selectedField || !searchValue) {
            deviceList({ page: 1, limit: rowsPerPage });
            setIsFiltering(false);
            setCurrentPage(1);
        }
    }, [selectedField, searchValue]);



    useEffect(() => {
        if (list) {
            setTotalPages(list?.totalPages);
        }
    }, [list])

    useEffect(() => {
        const params = {
            page: currentPage,
            limit: rowsPerPage,
        };

        if (isFiltering && selectedField && searchValue) {
            filterDeviceList({
                searchFor: selectedField.value,
                searchVal: searchValue,
                ...params
            });
        } else {
            deviceList(params);
        }
    }, [currentPage]);

    const searchForOptions = [
        {value: "device_id", label: "Device ID"},
        {value: "model", label: "Model"},
        {value: "manufacturer", label: "Manufacturer"},
        {value: "os_version", label: "OS Version"},
        {value: "status", label: "Status"},
        {value: "gateEntity", label: "Gate Entity"},
        {value: "gate_uid", label: "Gate UID"},
    ]

    return(
        <Box>
            <Box sx={{textAlign: "start"}}>
                <CustomHeader headerText={"Device Management"} />
            </Box>

            
                {isLoadingDevice ?
                    <CustomListviewLoader />
                :
                    <Paper elevation={0} sx={{border: `1px solid #e5edf6`, borderRadius: 2, padding: "24px 32px", mt: 3}}>
                        
                        <Box sx={{mt: 3, mb: 3}}>
                            {!viewDeviceDetails &&
                                <Box sx={{display: "flex", justifyContent: "right", alignItems:'center'}}>
                                    <Select
                                        styles={customStyles}
                                        options={searchForOptions}
                                        value={selectedField}
                                        onChange={handleFieldChange}
                                        placeholder="Select filter"
                                    />&nbsp;&nbsp;

                                    {selectedField && (
                                        <TextField
                                            // label={`Search ${selectedField.label}`}
                                            placeholder={selectedField.label}
                                            value={searchValue}
                                            onChange={handleInputChange}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    handleSearch();
                                                }
                                            }}
                                            sx={{
                                                "& .MuiInputBase-root": {
                                                    height: 42,
                                                    backgroundColor: "transparent",
                                                    width: 300, mr: 1
                                                }
                                            }}
                                            variant="outlined"
                                            autoComplete="off"
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <Typography
                                                            sx={{
                                                                fontSize: 12,
                                                                // opacity: 0.85,
                                                                fontStyle: "normal",
                                                                // color:'lightgray'
                                                            }}
                                                        >
                                                            Search:
                                                            {/* Search */}
                                                        </Typography>
                                                    </InputAdornment>
                                                ),
                                                style: {
                                                    padding: "10px",
                                                    fontSize: 14,
                                                    fontStyle: "italic"
                                                }
                                            }}
                                        />
                                    )}
                        {/* <RBACUIGuard requiredPermission={permissions.deviceManagement.REGISTER_DEVICE}>
                            <Stack direction="row"
                                spacing={2}
                                sx={{
                                    justifyContent: "end",
                                    alignItems: "center",
                                }}>
                                <CustomButton
                                    variant="contained" 
                                    startIcon={<AddIcon fontSize="small" />}
                                    label="Register Device"
                                    customStyles={{fontSize: 14, mt: 2, mb: 2}}
                                    onClick={() => navigate("/device-management/register")}
                                />
                            </Stack>
                        </RBACUIGuard> */}
                                </Box>
                            }
                           <DeviceManagementListComponent 
                                list={isFiltering ? filterList : list}
                                viewDeviceDetails={viewDeviceDetails} 
                                setViewDeviceDetails={setViewDeviceDetails}
                            />


                            {!viewDeviceDetails &&
                                <Pagination
                                    count={filterList?.data?.length ? filterList?.totalPages : totalPages}
                                    page={currentPage}
                                    onChange={handleChangePagination}
                                    sx={{
                                        margin: "auto",
                                        width: "fit-content",
                                        paddingTop: 3,
                                        "& .MuiPaginationItem-root.Mui-selected": {
                                            backgroundColor: "#0b99da",
                                            color: "#fff",
                                        }
                                    }}
                                />
                            }
                        </Box>
                    </Paper>
                }
            
        </Box>
    )
}